module.exports = __webpack_public_path__ + "img/HPHC_Card.f2c2526b.svg";